import React from 'react';

const TextMessage = ({ text }) => text ? <div className='chatterbox-text'>{text}</div> : null;

export default TextMessage;
